@import '../../shared';


.measurement {
  display: flex;

  span {
    padding: 0.5rem;
    margin-top: 0.5rem;
    color: $light-grey;
    font-size: $font-size-small;
  }

  input {
    width: unset;
  }
}

.form-input--hidden {
  display: flex;
  input {
    border: none;
    background: transparent;
    font-size: inherit;
    margin-left: .5rem;
  }
}

.form-input__container {
  position: relative;
}

.form-input__control {
  @include form-component;
  width: 100%;
  height: 4.4rem;
  font-size: inherit;
  border-radius: $border-radius-small;
  padding-left: 1.5rem;
  padding-right: 3.2rem;
  margin-bottom: 1.5rem;
  display: block;
  background-color: $white;

  &:focus {
    outline: none;
    border-color: $blue;
  }

  // &::-webkit-clear-button {
  //   display: none;
  // }

  &::-webkit-calendar-picker-indicator {
    height: 2.4rem;
    width: 2.4rem;
  }
}


label.form-input {
  width: 100%;
}



// .form-input__icon {
//   position: relative;
//   bottom: 5rem;
//   left:65%;
//   fill: $blue-page-heading;
// }

.form-input--centered {
  display: flex;
  justify-content: space-between;

  button, div.form-input-holder__container {
    width: 45%;
  }
}

.form-input--disabled {
  .form-input__control {
    @include form-component-disabled;
  }
}

.form-input--accept {
  .form-input__control {
    border-color: $green-border;
    &:focus {
      outline: none;
      border-color: $green-border;
    }
  }
  .form-input__icon {
    fill: $green;
  }
}

.form-input--reject {
  .form-input__control {
    border-color: $red-border;
    &:focus {
      outline: none;
      border-color: $red-border;
    }
  }
  .form-input__icon {
    fill: $red;
  }
}

// .form-input__icon {
//   position: absolute;
//   right: 0.5rem;
//   top: 0.625rem;
//   pointer-events: none;
// }

// .form-input__icon-internal {
//   position: absolute;
//   right: 0.5rem;
//   top: 0.625rem;
//   fill: $blue-text;
//   pointer-events: none;
// }
